module.exports = __webpack_public_path__ + "img/egg_circles.20f3493b.svg";